<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 36 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L14 14L2 26"
      :stroke="stroke"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 2L32 14L20 26"
      :stroke="stroke"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [String, Number], default: 36 },
    height: { type: [String, Number], default: 28 },
    stroke: { type: String, default: '#FFFFFF' },
  },
};
</script>
